import http from '@/util/http'

export default {
  updataPsd (data = {}) {
    return http({
      url: '/api/staffBase/editStaffSystem',
      method: 'post',
      data
    })
  },
  getAccountInfo (data = {}) {
    return http({
      url: `/api/staffBase/queryById/${data.id}`,
      method: 'get',
      data
    })
  },
  setUserQuickarea (data) {
    return http({
      url: '/api/systemNotice/setUserQuickData',
      method: 'post',
      data
    })
  },
  getUserQuickarea (data) {
    return http({
      url: '/api/systemNotice/getUserQuickData',
      method: 'post',
      data
    })
  },
  filterPowerMethods () {
    return http({
      url: '/api/staffBase/findPowerByLoginUser',
      method: 'get'
    })
  },
  // 财务看板数据
  getFinanceData (data) {
    return http({
      url: '/api/systemNoticeDataDashboard/finance',
      method: 'post',
      data
    })
  },
  // 采购看板数据
  getPurchaseData (data) {
    return http({
      url: '/api/systemNoticeDataDashboard/queryPurchase',
      method: 'post',
      data
    })
  },
  // 仓储看板数据
  getStoreData (data) {
    return http({
      url: '/api/systemNoticeDataDashboard/queryStorage',
      method: 'post',
      data
    })
  },
  /**
   * @author: wf
   * @createdate: 2021-01-19 11:10
   * @mark 经营状况看板
   */
  getBusinessStatus (data) {
    return http({
      url: '/api/systemNoticeDataDashboard/businessStatus',
      method: 'post',
      data
    })
  },
  /**
   * @author: wf
   * @createdate: 2021-01-19 11:11
   * @mark 个人销售看板
   */
  getPersonalSales(data = {}) {
    return http({
      url: '/api/systemNoticeDataDashboard/personalSales',
      method: 'post',
      data
    })
  },
  /**
   * @author: wf
   * @createdate: 2021-03-22
   * @mark: 团队销售看板
   */
  getSellteam(data = {}) {
    return http({
      url: '/api/systemNoticeDataDashboard/teamSalesStatus',
      method: 'post',
      data
    })
  },
  // 主页小铃铛
  workIndexNotice () {
    return http({
      url: '/api/systemNotice/queryMessageCount',
      method: 'post'
    })
  }
}
